// Author Eric
// Date 2024-09-06 15:06:08

class SithMesPrdFaultRecord {
constructor({
        id = null,
        faultTypeId = '',
        mstMachineType = '',
        item = '',
        operation = '',
        description = '',
        reason = '',
        repairMethod = '',
        solution = '',
        visibleInside = '',
        visibleSupplier = '',
        attachment = '',
        remark = '',
        attachmentList = ''}
= {}) {
    this.id = id;
    this.faultTypeId = faultTypeId;
    this.mstMachineType = mstMachineType;
    this.item = item;
    this.operation = operation;
    this.description = description;
    this.reason = reason;
    this.repairMethod = repairMethod;
    this.solution = solution;
    this.visibleInside = visibleInside;
    this.visibleSupplier = visibleSupplier;
    this.attachment = attachment;
    this.remark = remark;
    this.attachmentList = attachmentList;
}
}

function newEntity() {
return new SithMesPrdFaultRecord();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'faultType',
        label: 'label.sith.prd.sithMesPrdFaultRecord.grid.faultType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mstMachineTypeName',
        label: 'label.sith.prd.sithMesPrdFaultRecord.grid.mstMachineTypeName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'item',
        label: 'label.sith.prd.sithMesPrdFaultRecord.grid.item',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'operation',
        label: 'label.sith.prd.sithMesPrdFaultRecord.grid.operation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'description',
        label: 'label.sith.prd.sithMesPrdFaultRecord.grid.description',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'reason',
        label: 'label.sith.prd.sithMesPrdFaultRecord.grid.reason',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'repairMethod',
        label: 'label.sith.prd.sithMesPrdFaultRecord.grid.repairMethod',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'solution',
        label: 'label.sith.prd.sithMesPrdFaultRecord.grid.solution',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.prd.sithMesPrdFaultRecord.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.prd.sithMesPrdFaultRecord.grid.createdTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'attachmentList',
        label: 'label.sith.prd.sithMesPrdFaultRecord.grid.attachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdFaultRecord.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    faultTypeIdFilter : '',
    mstMachineTypeFilter : '',
    itemFilter : '',
    operationFilter : '',
    descriptionFilter : '',
    reasonFilter : '',
    repairMethodFilter : '',
    solutionFilter : '',
    createdTimeGteFilter : '',
    createdTimeLteFilter : '',
    remarkFilter : '',
    visibleInsideFilter : '',
    visibleSupplierFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'faultTypeIdFilter',
        label: 'label.sith.prd.sithMesPrdFaultRecord.filter.faultTypeId',
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'fault_type'
                }
        },
        {
        key: 'mstMachineTypeFilter',
        label: 'label.sith.prd.sithMesPrdFaultRecord.filter.mstMachineType',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesMstMachineType'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'itemFilter',
        label: 'label.sith.prd.sithMesPrdFaultRecord.filter.item',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'operationFilter',
        label: 'label.sith.prd.sithMesPrdFaultRecord.filter.operation',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'descriptionFilter',
        label: 'label.sith.prd.sithMesPrdFaultRecord.filter.description',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reasonFilter',
        label: 'label.sith.prd.sithMesPrdFaultRecord.filter.reason',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'repairMethodFilter',
        label: 'label.sith.prd.sithMesPrdFaultRecord.filter.repairMethod',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'solutionFilter',
        label: 'label.sith.prd.sithMesPrdFaultRecord.filter.solution',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdTimeGteFilter',
        label: 'label.sith.prd.sithMesPrdFaultRecord.filter.createdTimeGte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdFaultRecord.filter.createdTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remarkFilter',
        label: 'label.sith.prd.sithMesPrdFaultRecord.filter.remark',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'faultTypeId',
        label: 'label.sith.prd.sithMesPrdFaultRecord.entity.faultTypeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'fault_type'
                }
        },
        {
        key: 'mstMachineType',
        label: 'label.sith.prd.sithMesPrdFaultRecord.entity.mstMachineType',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesMstMachineType'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'item',
        label: 'label.sith.prd.sithMesPrdFaultRecord.entity.item',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'operation',
        label: 'label.sith.prd.sithMesPrdFaultRecord.entity.operation',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'description',
        label: 'label.sith.prd.sithMesPrdFaultRecord.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reason',
        label: 'label.sith.prd.sithMesPrdFaultRecord.entity.reason',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'repairMethod',
        label: 'label.sith.prd.sithMesPrdFaultRecord.entity.repairMethod',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'solution',
        label: 'label.sith.prd.sithMesPrdFaultRecord.entity.solution',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'visibleInside',
        label: 'label.sith.prd.sithMesPrdFaultRecord.entity.visibleInside',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'visibleSupplier',
        label: 'label.sith.prd.sithMesPrdFaultRecord.entity.visibleSupplier',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdFaultRecord.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'attachmentList',
        label: 'label.sith.prd.sithMesPrdFaultRecord.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
            ,correspondingField: 'attachment'
                }
        }
]

export {SithMesPrdFaultRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
